import axios from "axios";
import { toast } from "react-toastify";

import { startLoading, stopLoading } from "../Reducer/LoadingReducer";
import { handleAuthFail } from "./helper";

// export const seeBackendCallRequest = axios.interceptors.request.use(request => {
//     console.info('request data', JSON.stringify(request.data, null, 2))
//     return request
// })
// export const requestUrl = axios.interceptors.request.use(request => {
//     console.info('request Url', JSON.stringify(request.url, null, 2))
//     return request
// })
// export const seeBackendCallResponse = axios.interceptors.response.use(response => {
//     console.warn('Response data:', JSON.stringify(response.data, null, 2))
//     return response
// })
const options = {
    autoClose: 2000,
    className: "",
    position: toast.POSITION.TOP_RIGHT,
};
const useAxiosDispatch = async ({ method, url, data }, dispatch) => {
    try {
        dispatch(startLoading())
        return await axios({
            method: method || "post",
            url,
            data: { loginId: JSON.parse(localStorage.getItem("sadhan_user"))?.adminUserId || null, ...data },
            headers: {
                's-apiToken': process.env.REACT_APP_API_TOKEN,
                'S-sessionToken': JSON.parse(localStorage.getItem("sadhan_user"))?.sessionToken || null,
            },
        }).then(async (res) => {
            if (res.data.Error !== null) {
                handleAuthFail(res.data.Code);
                throw Error(res?.data?.Error?.message)
            } else if (res?.data?.Success !== null) {
                if (res?.data?.Success?.message !== null) {
                    toast.success(res?.data?.Success?.message);
                }
                return res?.data?.Success
            }
        }).catch(async ({ message }) => {
            toast.error(errorMessages[`${message}`] || message, options);
            return null
        }).finally(() => {
            dispatch(stopLoading())
        })
    } catch (error) {
        return null
    }

}


export default useAxiosDispatch;

export const errorMessages = {
    "Network Error": "Something went wrong",
    "Request failed with status code 401": "Unauthorized",
    "Request failed with status code 404": "Not Found",
    "Request failed with status code 500": "Internal Server Error",
    "Request failed with status code 502": "Bad Gateway",
    "Request failed with status code 503": "Service Unavailable",
    "Request failed with status code 504": "Gateway Timeout",
}